// extracted by mini-css-extract-plugin
module.exports = {"header--sticky":"Header_header--sticky__WTBlo","header--fallback":"Header_header--fallback__yf0RX","cat-part-diagram-cart-badge":"Header_cat-part-diagram-cart-badge__EHQt_"};